import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '../../shared/services/loader/loader.service';

/** Identifica o desenho do card; o template escolhe o traçado por este valor. */
type FuncionalidadeIcone = 'campanhas' | 'perfis' | 'questionarios' | 'termos';

interface Funcionalidade {
  titulo: string;
  icone: FuncionalidadeIcone;
  /** Uma linha dizendo o que se administra ali: só o título não distingue as telas entre si. */
  descricao: string;
  rota: string;
  /** Quando `true`, o card continua visível mas não navega para a `rota`. */
  desabilitado: boolean;
}

@Component({
  selector: 'app-funcionalidades',
  imports: [],
  templateUrl: './funcionalidades.component.html',
  styleUrl: './funcionalidades.component.scss',
})
export class FuncionalidadesComponent {
  funcionalidades: Funcionalidade[] = [
    {
      titulo: 'Gestão de Perfis',
      icone: 'perfis',
      descricao: 'Cadastre e mantenha os perfis de investimento oferecidos ao participante.',
      rota: '/perfis',
      desabilitado: false,
    },
    {
      titulo: 'Gestão de Questionários',
      icone: 'questionarios',
      descricao: 'Monte as perguntas e a pontuação que classificam o perfil do participante.',
      rota: '/questionarios',
      desabilitado: false,
    }
  ];

  constructor(
    private router: Router,
    private loaderService: LoaderService,
  ) {}

  navegar(funcionalidade: Funcionalidade): void {
    if (funcionalidade.desabilitado) {
      return;
    }

    this.loaderService.showLoader();
    this.router.navigate([funcionalidade.rota]);
    this.loaderService.hideLoader();
  }
}
